import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  Typography,
  CircularProgress,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import * as mainActions from '../actions';
import classes from '../../css/getCSS';


class Team extends Component {
  componentDidMount() {
    document.title = 'Team';
    if (!this.props.siteSettings) {
      this.props.getSiteSettings(
        this.props.site.id,
      );
    }
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let details = null;
    if (this.props.siteSettings) {
      details = <div className={classes.staticContent} dangerouslySetInnerHTML={{ __html: this.props.siteSettings.team }} />;  // eslint-disable-line
    }

    return (
      <React.Fragment>
        {loading}
        {errorAlert}
        {details}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    loading: state.main.loading,
    error: state.main.error,
    siteSettings: state.main.siteSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSiteSettings: siteID => dispatch(mainActions.getSiteSettings(siteID)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Team));



// WEBPACK FOOTER //
// ./src/main/components/Team.js